import { FontWeight } from '@hhgtech/hhg-components/mantine'
import { createStyles, keyframes, MantineColor, rem } from '@mantine/core'

import { ChartSizeType } from '../index.types'

type StyleParams = {
  color: MantineColor
  borderEndColorIndex: number
  borderStartColorIndex: number
  valueColorIndex: number
  endCircleAngle: number
  gapAngleLeft: number
  circleAngle: number
  firstLoading: boolean
  selectedDeg: number
  size: ChartSizeType
}

const rotate = keyframes({
  from: { transform: 'rotate(0deg)' },
  to: { transform: 'rotate(360deg)' },
})

export default createStyles(
  (
    theme,
    {
      color,
      borderStartColorIndex,
      borderEndColorIndex,
      valueColorIndex,
      endCircleAngle,
      gapAngleLeft,
      circleAngle,
      firstLoading,
      selectedDeg,
      size,
    }: StyleParams,
  ) => {
    const borderStartColor = theme.colors[color]?.[borderStartColorIndex]
    const borderEndColor = theme.colors[color]?.[borderEndColorIndex]
    const valueColor = theme.colors[color]?.[valueColorIndex]

    const center = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
    }
    const width = size === 'md' ? 40 : 32
    const height = size === 'md' ? 40 : 32
    const borderSize = 4

    return {
      root: {
        position: 'relative',
        borderRadius: '50%',
        width,
        height,
        '.warning-icon': {
          position: 'absolute',
          top: 0,
          left: '95%',
          zIndex: 1,
        },
      },
      border: {
        ...center,
        width,
        height: width,
        position: 'relative',
        background: theme.colors[color]?.[0],
        '&:before': {
          transform: 'rotate(135deg)',
          content: '""',
          position: 'absolute',
          inset: 0,
          borderRadius: 'inherit',
          background: `conic-gradient(
            from 180deg,
            transparent 0deg ${gapAngleLeft}deg,
            ${borderStartColor} ${gapAngleLeft}deg,
            ${borderEndColor} ${selectedDeg}deg,
            transparent ${selectedDeg}deg ${endCircleAngle}deg,
            transparent ${endCircleAngle}deg ${circleAngle}deg
          )`,
          ...(firstLoading && {
            animation: `${rotate} 2s linear infinite`,
            opacity: 0.5,
          }),
        },
      },

      borderWhite: {
        ...center,
        flexDirection: 'column',
        justifyContent: 'center',
        width: width - borderSize,
        height: width - borderSize,
        backgroundColor: theme.colors.neutral[0],
        zIndex: 1,
      },
      label: {
        fontSize: rem(size === 'md' ? 8 : 6),
        lineHeight: rem(size === 'md' ? 12 : 10),
      },
      value: {
        fontSize: rem(size === 'md' ? 15 : 13),
        lineHeight: rem(size === 'md' ? 15 : 13),
        fontWeight: size === 'md' ? FontWeight.semiBold : FontWeight.halfBold,
        color: valueColor,
      },
    }
  },
)
